import ConsentManagementService from "./ConsentManagementService";
import DataLayerService from "./DataLayerService";

class TrackingService {
  get hasConsent() {
    return ConsentManagementService.getConsent("google-analytics");
  }

  get measureId() {
    return "UA-150213971-1";
  }

  enableTracking() {
    if (this.hasConsent === false) {
      ConsentManagementService.observeCategory("google-analytics", () => this.enableTracking());
      return;
    }
    this.appendGAScript();
  }

  appendGAScript() {
    const script = document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${this.measureId}`);

    script.addEventListener("load", () => this.handleScriptLoad(), { once: true });
    document.body.appendChild(script);
  }

  handleScriptLoad() {
    DataLayerService.init();
    window.gtag("js", new Date());
    window.gtag("config", this.measureId);
  }
}

export default new TrackingService();
